const $ = require('jquery')

const { SELECTOR, BREAKPOINT, CLASS } = require('./api')

const $window = $(window)

// =========================================================================
// Header
// =========================================================================
module.exports = {
  init () {
    //Logo transition
    const $topLinks = $('.header__top-links')

    $('#burger').on('click', function() {
      SELECTOR.OVERLAY.fadeIn()
    })

    SELECTOR.OVERLAY.on('click', function(event) {
      event.preventDefault()
      SELECTOR.OVERLAY.fadeOut()
      $('.header .collapse').removeClass('in')
    })

    $('.close-menu').on('click', function() {
      SELECTOR.OVERLAY.fadeOut()
      $('.header .collapse').removeClass('in')
    })

    $('.mobile-back').on('click', function() {
      $(this).closest('.collapse').collapse('hide')
    })

    $('.mobileSearcher .searchButton').on('click', function() {
      $('.mobileSearcher').find('.acSearcher').show()
      $('.header__bottom-links').find('.navbar-toggle').hide()
      $('.header__bottom-links').find('.closeSearcher').show()
    })

    $('.header__bottom-links').find('.closeSearcher').on('click', function() {
      $('.mobileSearcher').find('.acSearcher').hide()
      $('.header__bottom-links').find('.navbar-toggle').show()
      $(this).hide()
    })

    $('.header__submenu > li > a').on('click', function() {
      $(this).siblings('div').addClass('in')
    })

    $('.header__bottom-links .header__nav > li > a[data-toggle="collapse"]').on('click', function(e) {
      if (window.innerWidth <= BREAKPOINT.DESKTOP) {
        e.preventDefault()
      }
    })

    if (window.innerWidth > BREAKPOINT.DESKTOP) {
      $('.header__submenu li button, .header__submenu > li > a').on('mouseenter', function(e) {
        $(this).closest('.header__submenu').find('li').removeClass('active')
        $(this).parent().addClass('active')

        if (window.innerWidth > BREAKPOINT.DESKTOP) {
          e.preventDefault()
        }
      })
    } else {
      $('.header__submenu li button, .header__submenu > li > a').on('click', function(e) {
        e.stopPropagation()
        $(this).closest('.header__submenu').find('li').removeClass('active')
        $(this).parent().addClass('active')
      })
    }
    let scrollTop = $(window).scrollTop()

    if (window.innerWidth <= BREAKPOINT.TABLET) {
      if (scrollTop > 0) {
        $topLinks.show()
      } else {
        $topLinks.css('display', '')
      }
    }

    let offerContentShort = $('.offer-content__short')
    if (offerContentShort.exists()) {
      offerContentShort = offerContentShort.offset().top
    }

    $window.on('scroll', function() {
      scrollTop = $(this).scrollTop()

      if (window.innerWidth <= BREAKPOINT.TABLET) {
        if (scrollTop > 0) {
          $topLinks.stop(true, true).fadeIn()
          if ($('.btn-book')) {
            if (scrollTop > offerContentShort) {
              $('.btn-book').addClass('fixed')
            } else {
              $('.btn-book').removeClass('fixed')
            }
          }
        } else {
          $topLinks.stop(true, true).fadeOut(function() {
            $(this).css('display', '')
          })
        }
      }
    })
  },

  handleMenu () {
    const collapseMenuSelector = $('.header__bottom-links .header__nav > li')
    let openedMenu = false
    let timer = null

    const startOpeningMenu = function(el) {
      if (window.innerWidth > BREAKPOINT.DESKTOP) {
        const $el = $(el.currentTarget)
        const $target = $el.find('.header__hover-block')
        openedMenu = false

        if (!openedMenu) {
          timer = setTimeout(function() {
            $target.parent().addClass('active')
            $target.addClass('in')
            openedMenu = true
          }, 200)
        } else {
          $target.addClass('in')
        }
      }
    }

    const closeOpenedMenu = function() {
      if (window.innerWidth > BREAKPOINT.DESKTOP) {
        clearTimeout(timer)
        openedMenu = false
        $('.header__hover-block').removeClass('in')
        collapseMenuSelector.removeClass('active')
      }
    }

    if (!$('.header_experienceEdit').length) {
      collapseMenuSelector.on('mouseenter', startOpeningMenu)
      collapseMenuSelector.on('mouseleave', closeOpenedMenu)
    }

    const headerDesktopOperations = function() {
      if (window.innerWidth > BREAKPOINT.DESKTOP) {
        collapseMenuSelector.find('a').removeAttr('data-toggle')
        collapseMenuSelector.on('click', 'a', function() {
          const el = $(this).parent().find('.header__hover-block')

          if (!el.hasClass('in')) {
            $('.header__hover-block').removeClass('in')
            el.addClass('in')
          } else {
            el.removeClass('in')
          }
        })
      }
    }

    const init = function() {
      return {
        headerDesktopOperations: headerDesktopOperations(),
      }
    }

    return init()
  },

  logo (initScroll) {
    const $logo = $('.navbar-fixed-top .logo')

    if (initScroll) {
      $window.scroll(function() {
        const scrollTop = $(this).scrollTop()
        if (scrollTop > 0) {
          $logo.stop(true, true).addClass(CLASS.SCROLL_LOGO)
        } else {
          $logo.stop(true, true).removeClass(CLASS.SCROLL_LOGO)
        }
      })
      return false
    } else {
      return false
    }
  },
}



// WEBPACK FOOTER //
// ./src/modules/header.js